export default __webpack_public_path__ + "static/media/Need-successful-project-icon.48779cbe.svg";